import { render } from "./roomDetails.vue?vue&type=template&id=1c0fe304&scoped=true"
import script from "./roomDetails.vue?vue&type=script&lang=js"
export * from "./roomDetails.vue?vue&type=script&lang=js"

import "./roomDetails.vue?vue&type=style&index=0&id=1c0fe304&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0fe304"]])

export default __exports__